/**
 * The month-to-date window spend is reported over, plus how much of that window has elapsed.
 *
 * `endDate` is yesterday because reporting data lands a day behind. On the 1st that would put the
 * end before the start, so `hasElapsedDays` is false and there is no window to query at all —
 * callers must not fetch, and must not render 0% (which reads as "nothing spent" rather than
 * "nothing measured yet"). See getSpendProgress.test.ts.
 */
export type SpendWindow = {
  startDate: Date;
  endDate: Date;
  hasElapsedDays: boolean;
};

export function getSpendWindow(now: Date): SpendWindow {
  const dayOfMonth = now.getDate();
  const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
  const endDate = new Date(now.getFullYear(), now.getMonth(), dayOfMonth - 1);
  const hasElapsedDays = dayOfMonth > 1;

  return {
    startDate,
    endDate: hasElapsedDays ? endDate : startDate,
    hasElapsedDays,
  };
}

export function getPercentSpent(
  spend: number,
  budget: number | null | undefined
): number | null {
  if (typeof budget !== "number" || budget <= 0) {
    return null;
  }

  return (spend / budget) * 100;
}
